"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConferencingFooter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIcons = require("@100mslive/react-icons");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _AudioVideoToggle = require("../AudioVideoToggle");
var _LeaveRoom = require("../LeaveRoom");
var _MoreSettings = require("../MoreSettings/MoreSettings");
var _ScreenShare = require("../ScreenShare");
var _ScreenshareHintModal = require("../ScreenshareHintModal");
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _PIPComponent = _interopRequireDefault(require("../PIP/PIPComponent"));
var _MetaActions = _interopRequireDefault(require("../MetaActions"));
var _ChatToggle = require("./ChatToggle");
var _Playlist = require("../../components/Playlist/Playlist");
var _NoiseSuppression = require("../../plugins/NoiseSuppression");
var _whiteboard = require("../../plugins/whiteboard");
var _VirtualBackground = require("../../plugins/VirtualBackground/VirtualBackground");
var _FeatureFlags = require("../../services/FeatureFlags");
var _utils = require("../../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TranscriptionButton = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../../plugins/transcription"));
  });
});
var ScreenshareAudio = function ScreenshareAudio() {
  var _useScreenShare = (0, _reactSdk.useScreenShare)(),
    amIScreenSharing = _useScreenShare.amIScreenSharing,
    video = _useScreenShare.screenShareVideoTrackId,
    audio = _useScreenShare.screenShareAudioTrackId,
    toggleScreenShare = _useScreenShare.toggleScreenShare;
  var isAllowedToPublish = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsAllowedToPublish);
  var isAudioScreenshare = amIScreenSharing && !video && !!audio;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  if (!isAllowedToPublish.screen || !(0, _utils.isScreenshareSupported)()) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
      title: "".concat(!isAudioScreenshare ? "Start" : "Stop", " audio sharing"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        active: !isAudioScreenshare,
        onClick: function onClick() {
          if (amIScreenSharing) {
            toggleScreenShare(true);
          } else {
            setShowModal(true);
          }
        },
        "data-testid": "screenshare_audio",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.MusicIcon, {})
      })
    }, "shareAudio"), showModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenshareHintModal.ScreenShareHintModal, {
      onClose: function onClose() {
        return setShowModal(false);
      }
    })]
  });
};
var ConferencingFooter = function ConferencingFooter() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Footer.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Footer.Left, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ScreenshareAudio, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Playlist.Playlist, {
        type: _reactSdk.HMSPlaylistType.audio
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Playlist.Playlist, {
        type: _reactSdk.HMSPlaylistType.video
      }), _FeatureFlags.FeatureFlags.enableWhiteboard ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_whiteboard.ToggleWhiteboard, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_VirtualBackground.VirtualBackground, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoiseSuppression.NoiseSuppression, {}), _FeatureFlags.FeatureFlags.enableTranscription && /*#__PURE__*/(0, _jsxRuntime.jsx)(TranscriptionButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
        align: "center",
        css: {
          display: "none",
          "@md": {
            display: "flex"
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MetaActions["default"], {
          isMobile: true
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Footer.Center, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AudioVideoToggle.AudioVideoToggle, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenShare.ScreenshareToggle, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PIPComponent["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreSettings.MoreSettings, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaveRoom.LeaveRoom, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
        align: "center",
        css: {
          display: "none",
          "@md": {
            display: "flex"
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatToggle.ChatToggle, {})
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Footer.Right, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MetaActions["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatToggle.ChatToggle, {})]
    })]
  });
};
exports.ConferencingFooter = ConferencingFooter;